import React, { Component } from "react";
import { ListGroup } from "react-bootstrap";
import { API } from "aws-amplify";
//
import TimelineHeader from "./Timeline/TimelineHeader";
import TimelineList from "./Timeline/TimelineList";
import Thread from "./Timeline/Thread";
import "./Timeline.css";


export default class Timeline extends Component {
  constructor(props) {
    super(props);

    this.state = {
      didMount: false,
      accountId: "TEST TEST TEST", // FIX THIS !!! FIX !!!
      contactId: 'toddcolby@gmail.com', // TODO --- default to user --- FIX !!!
      contactCards: {},
      showContactInfo: false,
      showEditReply: false,
      replyToItem: '',
      thread: [],
      selectedThread: {},
      timeline: [],
    };
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) return;
  
    try {
      if (this.props.match.params.contactId) {
        await this.setState({ contactId: this.props.match.params.contactId });
      }
      const timeline = await this.timeline();
      this.setState({ timeline });
      this.setState({ selectedThread: timeline[0] });
      const contactCards = await this.contactCards(this.state.contactId, this.state.accountId);
      this.setState({ contactCards });

    } catch (e) {
      alert(e);
    }
  
    this.setState({ didMount: true });
  }
  
  contactCards(contactId, accountId) {
    return API.post("contacts", `/contacts/${contactId}`, { body: { accountId }});
    // return API.get("contacts", `/contacts/${contactId}`);
  }

  timeline() {
    return API.get("contacts", `/events/${this.state.contactId}`);
  }

  
  handleAddClick = async event => {
    event.preventDefault();
    console.log('clicked Add new');
  }

  toggleShowContactInfo = () => {
    const doesShow = this.state.showContactInfo;
    this.setState( { showContactInfo: !doesShow } );
  }

  handleSelectThread = (selectedThread) => {
    this.setState({ selectedThread });
  }

  handleClickReply = (key) => {
    const doesShow = this.state.showEditReply;
    this.setState({ 
      showEditReply: !doesShow,
      replyToItem: key,
    });
  }


  renderTimeline() {
    return (
      <div className="Timeline">
        <div className="eXa-container">
          <TimelineHeader
            contactId={this.state.contactId}
            contactCards={this.state.contactCards}
            clicked={this.toggleShowContactInfo}
            showContactInfo={this.state.showContactInfo}
            didMount={this.state.didMount}
          />
          <div className="eXa-col m6">
            <ListGroup>
              <TimelineList
                didMount={this.state.didMount}
                timeline={this.state.timeline}
                clicked={this.handleSelectThread}
              />
            </ListGroup>
          </div>
          <div className="eXa-col m6">
            <Thread
              didMount={this.state.didMount}
              selectedThread={this.state.selectedThread}
              showEditReply={this.state.showEditReply}
              clicked={this.handleClickReply}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="Timeline">
        {this.props.isAuthenticated ? this.renderTimeline() : this.renderLander()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Timeline.js